import React from "react";
import { FormattedMessage } from "react-intl";
const MiniMiranda = (props) => (<p {...props}>
		<FormattedMessage id="miniMiranda" defaultMessage={"This company is a debt collector attempting to collect a debt and any information obtained "
    + "will be used for that purpose. Calls may be monitored or recorded."}/>
	</p>);
export default MiniMiranda;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/MiniMiranda/MiniMiranda.tsx